<template>
    <div class="show_month">
        <ul>
            <li v-for="item in options" :key="item" :class="{ active: item === month && !isDisabled(item), disabled: isDisabled(item) }" @click="handleClick(item)">
                {{ item }}
            </li>
        </ul>
    </div>
</template>

<script setup>
import { computed } from "vue";
import useDateStore from "@/store/modules/useDate";

const dateStore = useDateStore();
const year = computed(() => Number(dateStore.year));
const month = computed(() => dateStore.month);
const options = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth() + 1;

function isDisabled(monthItem) {
    if (year.value < currentYear) {
        return false;
    }
    if (year.value === currentYear) {
        return monthItem > currentMonth;
    }
    return false;
}

function handleClick(item) {
    if (isDisabled(item)) return;
    dateStore.setMonth(item);
}
</script>

<style lang="scss" scoped>
.show_month {
    ul {
        display: flex;
        align-items: center;

        li {
            width: 20px;
            height: 20px;
            text-align: center;
            font-size: 12px;
            color: #fff;
            margin-right: 8px;
            font-weight: bold;
            user-select: none;
            cursor: pointer;

            &:last-child {
                margin-right: 0;
            }

            &.active {
                color: #fff;
                border-radius: 50%;
                background-color: var(--week-primary-color);
            }

            &.disabled {
                color: #999;
                cursor: not-allowed;
            }
        }
    }
}
</style>
